import React from "react";
import { useState } from "react";
import logo from '../../images/logo.png'
import '../navbar/navbar.css'
import Form from '../form-component/form.js'

function Navbar() {
    const [showForm, setShowForm] = useState(false);


    function signUp(change) {
        setShowForm(change);
        console.log(change)
        window.scrollTo({
            top: 50,
            behavior: 'smooth',
        });
    }
    return (
        <div>
     <div className="container">
            <div className="navbarLogo">
                <img className="myLogo" src={logo} alt="myLogo" />
            </div>
            <div className="navbarMenu">
                <button onClick={signUp} className="reachoutbtn"> Reach Out</button>
            </div>
           
        </div>
        {showForm ? <Form signUp={signUp} /> : null}
        </div>
   
    )
}
export default Navbar;